export const urlTypes = {
  payment: 'payment',
  activation: 'activation',
  addMethod: 'addMethod'
}
